import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from '../confirmation/confirmation-modal.component'
import { Subject } from 'rxjs/Subject';
import { clone, difference, filter, contains, toLower } from 'ramda/es';
import { reduce, keys, uniq, concat } from 'ramda';
import { TranslateService } from '@ngx-translate/core';

export interface ILabels {
  title: string;
  confirmTitile: string;
  importButton: string;
  clearButton: string;
  confirmButton: string;
  cancelButton: string;
}

@Component({
  selector: 'mailinglist-modal',
  templateUrl: './mailinglist-modal.component.html',
  styleUrls: ['./mailinglist-modal.component.scss']
})
export class MailingListModalComponent implements OnInit, OnDestroy {
  public active: boolean = false;
  public search: boolean = false;
  public onUpdate: Subject<{add: Array<string>, remove: Array<string>, update: Array<string>}>;

  public labels: ILabels = {title: '', confirmTitile: '', importButton: '', clearButton: '', confirmButton: '', cancelButton: ''};
  public mailingAddress = '';
  public mailingList: Array<string> = [];
  public mailingListOriginal: Array<string> = [];
  public mailingListDisplay: Array<string> = [];
  public criteria;
  public users: any[];

  public constructor(
      private _bsModalRef: BsModalRef,
      private modalService: BsModalService,
      private translateService: TranslateService) {
  }

  ngOnDestroy() {
  }
  public ngOnInit(): void {
    this.onUpdate = new Subject();
  }

  public showModal(
      labels: ILabels, 
      mailingList: Array<string>,
      users: Array<any> = [],
      search: boolean = false): Subject<{add: Array<string>, 
      remove: Array<string>, 
      update: Array<string>}> {
    this.active = true;
    this.labels = labels;
    this.mailingList = clone(mailingList);
    this.mailingListOriginal = clone(mailingList);
    this.search = search;
    this.users = users;
    this.displayMailingList();
    return this.onUpdate;
  }

  public onConfirm(): void {
    // save without confirmation
    this.onUpdate.next({
        add: difference(this.mailingList, this.mailingListOriginal),
        remove: difference(this.mailingListOriginal, this.mailingList),
        update: clone(this.mailingList)
    });
    this.active = false;
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.active = false;
    this._bsModalRef.hide();
  }

  public onClear(): void {
    const modal = this.modalService.show(ConfirmationModalComponent);
    (<ConfirmationModalComponent>modal.content).showConfirmationModal(
        this.labels.confirmTitile
    );

    const closeSource$ = (<ConfirmationModalComponent>modal.content).onClose;
    closeSource$.subscribe(result => {
        if (result) {
          // remove all 
          this.onUpdate.next({
              add: [],
              remove: clone(this.mailingListOriginal),
              update: []
          });
          this.active = false;
          this._bsModalRef.hide();
        } else {
          //reopen
          const ref = this.modalService.show(MailingListModalComponent, { class: 'inmodal' });
          const m:MailingListModalComponent = ref.content;
          m.showModal(this.labels, this.mailingList);
          m.onUpdate = this.onUpdate;
          m.mailingListOriginal = this.mailingListOriginal;
        }
    });
    this._bsModalRef.hide();
    this.displayMailingList();
  }

  removeEmailAddress(email: string) {
    this.mailingList.splice(this.mailingList.indexOf(email), 1);
    this.displayMailingList();
  }

  public addEmailAddress() {
    const value = this.mailingAddress.trim()
    if (this.validatLine(value)) {
      this.mailingList.push(value);
      this.mailingAddress = '';
    }
    this.displayMailingList();
  }

  private validatLine(value: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  private filterMailingList(mailingList: Array<string>, criteria: string) {
    if (!criteria) {
      return clone(mailingList);
    }
    return filter(e => contains(toLower(criteria), toLower(e)), mailingList);
  }

  private displayMailingList() {
    this.mailingListDisplay = this.filterMailingList(this.mailingList, this.criteria);    
  }

  public onChange($event) {
    this.displayMailingList();
  }

  public onImport($event) {
    if (this.users.length <= 0) {
      toastr.error(this.translateService.instant('sessions.details.emails.error_import_no_users'));
      return;
    }
    const usersEmails = reduce((acc, user) => {
      const key: string = keys(user).find((prop: string) => prop.toLowerCase() === 'email');
      const email: string = key ? user[key] : null;
      return email ? [ ...acc, email ] : acc;
    }, [])(this.users);
    if (usersEmails.length <= 0) {
      toastr.error(this.translateService.instant('sessions.details.emails.error_import_no_emails'));
      return;
    }
    this.mailingList = uniq(concat(this.mailingList, usersEmails));
    this.displayMailingList();
    toastr.success(this.translateService.instant('action.success'));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/modals/mailinglist/mailinglist-modal.component.ts